import { AppConfigReqPayload } from "../../central-atoms/org-app-map/types";
import { AppRemoteConfigResponse } from "../../central-atoms/org-app-map/types/responses";
import HttpRequestService from "../../config/HttpRequestService";
import { GLOBAL_VARS } from "../../constants";
import { getGlobalVar } from "../../miscellaneous/helpers";

export default class RemoteConfigRequestService {
    static fetchRemoteConfig(payload: AppConfigReqPayload): Promise<{data: AppRemoteConfigResponse}> {
        const centralHttpRequest: HttpRequestService = getGlobalVar(GLOBAL_VARS.centralHttpRequest);
        return centralHttpRequest.getInstance()
            .post(`/config/remote`,payload)
            .then((response: any) => {
                return response.data;
            });
    }
}

